// extracted by mini-css-extract-plugin
module.exports = {"h5button":"fp","h5Button":"fp","button":"fq","block":"fr","btnDefault":"fs","disable":"ft","btnPrimary":"fu"};